<template>

    <fragment>

        <div v-if="editable && dataStore.questionType === 'freetext'">
            <div class="form-check">
                <input type="checkbox" class="allow-image-upload form-check-input" v-model="dataStore.allowUploadImage" id="allow-image-upload-image">
                <label class="form-check-label" for="allow-image-upload-image">{{ language.add_type_allow_image }}</label>
            </div>
        </div>

        <div class="form-group">
            <label for="survey-question">{{ language.add_type_text_label }}</label>
            <textarea v-if="editable" v-model="dataStore.activeQuestion" class="form-control" id="survey-question" rows="3"></textarea>
            <p class="not-allow-edit" v-if="!editable">{{ dataStore.activeQuestion }}</p>
            <span style="color: red; display: block; clear: both;" v-if="error">{{ error.error }}</span>
        </div>

    </fragment>

</template>

<script>

import dataStore from "../../store";
import globalFunctions from "../../globalFunctions";
import { Fragment } from 'vue-fragment'

export default {

    data() {
        return {
            dataStore,
            globalFunctions,
        }
    },

    inject: [ 'language', 'superadmin' ],

    components: {
        Fragment
    },

    computed: {

        editable: function() {
            return this.superadmin ? true : ( this.dataStore.project.allowToEdit && this.dataStore.isLoaded )
        },

        error: function() {
            if(this.dataStore.errorsAdmin.length) {
                let error = this.dataStore.errorsAdmin.filter(err => err.name === 'text').pop()
                return error ? error : false
            }

            return false
        }

    },
};
</script>
